import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { z } from 'zod';

export const BetterAuthUserSchema = z.object({
	id: z.string(),
	createdAt: z.date().optional(),
	updatedAt: z.date().optional(),
	email: z.string().nullable().optional(),
	emailVerified: z.boolean().default(false),
	name: z.string(),
	image: z.string().nullable().optional(),
	username: z.string(),
	role: z.string().optional(),
	MaCB: z.string().optional(),
	maKhoa: z.string().optional(),
	writable: z.boolean().optional(),
}).strip();

const UserStateSchema = z.object({
	user: BetterAuthUserSchema.nullable(),
	isLoading: z.boolean(),
	isAuthenticated: z.boolean(),
	error: z.string().nullable(),
}).strip();

type UserState = z.infer<typeof UserStateSchema>;

const initialState: UserState = {
	user: null,
	isLoading: true,
	isAuthenticated: false,
	error: null,
};

const userSlice = createSlice({
	name: 'user',
	initialState,
	reducers: {
		setUser: (state, action: PayloadAction<z.infer<typeof BetterAuthUserSchema> | null>) => {
			state.user = action.payload;
			state.isAuthenticated = action.payload !== null;
			state.isLoading = false;
			state.error = null;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.isLoading = action.payload;
		},
		setError: (state, action: PayloadAction<string | null>) => {
			state.error = action.payload;
			state.isLoading = false;
		},
		clearUser: (state) => {
			state.user = null;
			state.isAuthenticated = false;
			state.isLoading = false;
			state.error = null;
		},
	},
});

export const { setUser, setLoading, setError, clearUser } = userSlice.actions;
export default userSlice.reducer;
